import React, { useEffect, useState } from 'react';
import FooterWImageAndActionButtons from '../../../components/footerwimageandactionbuttons/FooterWImageAndActionButtons';
import { HEADING } from '../../../components/heading/constants/constants';
import Heading from '../../../components/heading/Heading';
import styles from './AccountingSoftwaresInfo.styles';
import commonStyles from '../OnboardingStepsCommonStyles';
import { ONBOARDING_LOADING_STATES, ONBOARDING_ROUTES, ONBOARDING_STATES_MESSAGE_MAP } from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey as onboardingComponentKey, setOnboardingData } from '../OnboardingSlice';
import CheckboxWLabel from '../../../components/checkbox/checkboxwlabel/CheckboxWLabel';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { saveOnboardingData } from '../OnboardingSaga';
import { setOnboardingPending } from '../../dashboard/DashboardSlice';
import Loadable from '../../../components/loadable/Loadable';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';
import { OVERRIDE_ACCOUNTING_SOFTWARES } from './constants';

export default function AccountingSoftwaresInfo() {

    const { loadingState, onboardingData, onboardingFormOptionsData } = useSelector((state) => state[onboardingComponentKey]);
    let selectedSoftwaresList = onboardingData.AccountingTypes;
    const accountingSoftwaresList = onboardingFormOptionsData?.AccountingTypes ?? [];
    const [selectedAccountingSoftwares, setSelectedAccountingSoftwares] = useState([]);
    const navigate = useTxNavigate();
    const dispatch = useDispatch();

    const [disabled, setDisabled] = useState(false);
    const [lastSelectedSpecial, setLastSelectedSpecial] = useState(null);

    useEffect(() => {
        setSelectedAccountingSoftwares(() => accountingSoftwaresList.map((item) => {
            return {
                ...item,
                checked: selectedSoftwaresList.includes(item.id)
            };
        }));
    }, [accountingSoftwaresList, selectedSoftwaresList]);

    const handleSelectSoftware = (checked, i) => {
        let temp = selectedAccountingSoftwares[i];
        temp.checked = !checked;
        let selectedAccountingSoftwaresClone = [...selectedAccountingSoftwares];
        selectedAccountingSoftwaresClone[i] = temp;
        setSelectedAccountingSoftwares([...selectedAccountingSoftwaresClone]);

        selectedSoftwaresList = [];
        selectedAccountingSoftwaresClone.map((item, idx) => {
            if (item.checked) {
                selectedSoftwaresList.push(item.id)
            }
        });

        let updatedSoftwares = selectedAccountingSoftwares.map((software, idx) => {
            if (idx === i) {
                return { ...software, checked: !checked };
            }
            return software;
        });

        const selectedIds = updatedSoftwares.filter(software => software.checked).map(software => software.id);
        const isSpecialChecked = OVERRIDE_ACCOUNTING_SOFTWARES.some(id => selectedIds.includes(id));
        const selectedSpecialCheckbox = OVERRIDE_ACCOUNTING_SOFTWARES.find(id => selectedIds.includes(id));

        if (isSpecialChecked) {
            updatedSoftwares = updatedSoftwares.map((software, idx) => {
                if (OVERRIDE_ACCOUNTING_SOFTWARES.includes(software.id) && software.id !== selectedSpecialCheckbox) {
                    return { ...software, checked: false };
                } else if (!OVERRIDE_ACCOUNTING_SOFTWARES.includes(software.id)) {
                    return { ...software, checked: false };
                }
                return software;
            });
        }

        setDisabled(isSpecialChecked);
        setLastSelectedSpecial(selectedSpecialCheckbox);
        setSelectedAccountingSoftwares(updatedSoftwares);
        dispatch(setOnboardingData({ AccountingTypes: updatedSoftwares.filter(software => software.checked).map(software => software.id) }));
    };

    const handleSubmit = () => {
        if (onboardingData.AccountingTypes.length < 1) {
            dispatch(addNotifications({ heading: "Accounting software data is required", message: "To continue, please select the option that is relevant to you" }))
        } else {
            dispatch(saveOnboardingData({ onboardingDataToSave: onboardingData, goToNextScreenCb: setOnboardingPending, nextScreenStateValue: false }));
        }
    };


    return (
        <>
            <Loadable
                currentState={loadingState.state}
                loadingStates={[ONBOARDING_LOADING_STATES.SAVE_ONBOARDING_ACTION_LOADING]}
                messageMap={ONBOARDING_STATES_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <div style={commonStyles.onboardingStepContainer}>
                    <div style={{ ...commonStyles.formDiv, ...styles.formDivFullWidth }}>
                        <div style={styles.stepTitleContainer}>
                            <Heading type={HEADING.H1}>Which Accounting Software do you Use?</Heading>
                            <div>
                                <p style={styles.stepTitleDesc}>
                                </p>
                            </div>
                        </div>
                        <div style={styles.softwaresSelectionArea}>
                            {
                                selectedAccountingSoftwares.map((software, idx) => (
                                    <div style={styles.checkboxItem} key={software.id}>
                                        <CheckboxWLabel
                                            label={software.Label}
                                            checked={software.checked}
                                            onChangeCb={() => handleSelectSoftware(software.checked, idx)}
                                            disabled={disabled && (!OVERRIDE_ACCOUNTING_SOFTWARES.includes(software.id) || software.id !== lastSelectedSpecial)}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <FooterWImageAndActionButtons
                        backButton={{
                            text: "Back",
                            clickCb: () => { navigate(`/${ONBOARDING_ROUTES.ONBOARDING}/${ONBOARDING_ROUTES.FORM_QUANTITY}`) },
                        }}
                        nextButton={{
                            text: "Submit",
                            clickCb: handleSubmit,
                        }}
                    >
                        <span>The deadline to mail 1099s to taxpayers is usually Jan. 31.</span>
                    </FooterWImageAndActionButtons>
                </div>
            </Loadable>
        </>
    )
}